import React from 'react';
import { NavLink as RouterLink } from 'react-router-dom';

import styled from '@emotion/styled';

interface IAuthLayout {
  children?: any;
  label?: string;
  linkTitle?: string;
  linkPath?: string;
  formHeaderTitle?: string;
  formHeaderDescription?: string | React.ReactNode;
  forgotPassword?: boolean;
  headerImgSrc?: string;
}

export const AuthLayout: React.FC<IAuthLayout> = ({
  children,
  label,
  linkTitle,
  linkPath,
  formHeaderTitle,
  formHeaderDescription,
  forgotPassword,
  headerImgSrc,
}) => {
  return (
    <Container>
      <FormArea>
        <FormAreaHeader>
          <CompanyLogo src="/static/svg/company-letter-logo.svg" />
          <LinkArea>
            <LinkSection>
              <LinkSectionLabel>{label}</LinkSectionLabel>{' '}
              <Link to={linkPath || '/'}>{linkTitle}</Link>{' '}
            </LinkSection>
          </LinkArea>
        </FormAreaHeader>
        <FormSectionWrapper>
          <FormSection>
            {headerImgSrc && <FormSectionHeaderImg src={headerImgSrc} />}
            <FormSectionHeader>
              <FormSectionHeaderTitle>{formHeaderTitle}</FormSectionHeaderTitle>
              <FormSectionHeaderDescription>
                {formHeaderDescription}
              </FormSectionHeaderDescription>
            </FormSectionHeader>
            <FormBody>{children}</FormBody>
            {forgotPassword && (
              <ForgotPasswordLink to="/account/reset-password">
                Forgot password
              </ForgotPasswordLink>
            )}
          </FormSection>
        </FormSectionWrapper>
      </FormArea>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  background-color: #f8f9fa;

  @media (max-width: 480px) {
    width: 100%;
    padding: 1rem;
    /* border: 2px solid yellow; */
  }
`;

const FormArea = styled.div`
  margin: 2rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 3rem;

  @media (max-width: 480px) {
    display: flex;
    flex-direction: column;
    gap: 3rem;
    width: 100%;
    margin: 0px auto;
  }
`;

const FormSectionHeaderImg = styled.img`
  /* border: 2px solid red; */
  width: 16rem;
  align-self: center;
  margin: auto;
`;

const FormBody = styled.div`
  /* border: 2px solid green; */
  @media (max-width: 480px) {
    display: flex;
    justify-content: center;
    width: 100%;
  }
`;

const FormSectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* border: 2px solid blue; */

  @media (max-width: 480px) {
    width: 100%;
  }
`;

const FormSectionHeaderTitle = styled.div`
  display: flex;
  text-align: center;
  font-size: 1.5rem;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.primaryText};
`;

const FormSectionHeaderDescription = styled.div`
  display: flex;
  text-align: center;
  font-size: 1rem;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.secondaryText};

  margin-left: 15%;
  margin-right: 15%;
`;

const FormAreaHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CompanyLogo = styled.img``;

const LinkArea = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: 480px) {
    gap: 0px;
  }
`;

const LinkSection = styled.div`
  color: ${({ theme }) => theme.palette.tertiaryText};
  font-weight: 400;
`;

const LinkSectionLabel = styled.span`
  @media (max-width: 480px) {
    display: none;
  }
`;

const Link = styled(RouterLink)`
  /* border: 2px solid red; */
  text-decoration: none;
  color: ${({ theme }) => theme.palette.brandPrimary};
  font-weight: 700;
`;

const ForgotPasswordLink = styled(Link)`
  text-align: center;
`;

const FormSectionWrapper = styled.div`
  /* height: 100%; */
  display: grid;
  /* border: 2px solid yellow; */
  place-content: center;
`;

const FormSection = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.text1};
  border-radius: 0.5rem;
  width: 28.875rem;
  height: fit-content;
  padding: 2.5rem;
  display: grid;
  gap: 1.5rem;
  background-color: white;

  @media (max-width: 480px) {
    background-color: transparent;
    border: none;
  }
`;
